<template>
  <div>
    <v-row dense class="mx-1">
      <v-btn depressed
             color="primary"
             link to="/cadastro-configuracoes-frete"
             class="normal-btn-text rounded-tag-small">
        <v-icon left>mdi-plus</v-icon>
        Configuração de frete
      </v-btn>
      <v-spacer/>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-search-text label="Busque por uma configuração" v-model="searchText"
                      style="max-width: 400px"
                      class="rounded-card"
                      :on-search="onChangeSearchText"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    onChangeFilter: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('listagemConfiguracaoFrete', ['stringFilter']),
    searchText: {
      get() {
        return this.$store.getters['listagemConfiguracaoFrete/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemConfiguracaoFrete/searchText', searchText);
      },
    },
  },
  methods: {
    onChangeSearchText() {
      this.onChangeFilter(this.stringFilter);
    },
    onSelectItem() {
      this.onChangeFilter(this.stringFilter);
    },
  },
};
</script>
